import { HttpClient } from "@angular/common/http";
import { EventEmitter, Injectable } from "@angular/core";
import { ApiPaginationResponseDataNonNullable } from "app/shared/models/api-response.model";
import { Observable } from "rxjs";
import { AuthService } from "../../base-module/base-service/auth.service";
import { UtilitesService } from "../../base-module/base-service/utilites.service";
import { ParceiroCartaConsorcioModel } from "../models/parceiro-carta-consorcio.model";

@Injectable()
export class ParceiroCartaConsorcioService {
    public empresaPadrao = new EventEmitter<Record<string, unknown>>();

    private baseURL = "consorcio/parceiro-carta-consorcio";

    constructor(private authService: AuthService, private _http: HttpClient, public utilitesService: UtilitesService) {}

    /**
     * Busca um Parceiro de Carta Consórcio por ID
     * @param id ID do Parceiro de Carta Consórcio
     * @returns Observable contendo os dados do parceiro
     */
    getById(id: number): Observable<any> {
        return this._http.get(this.utilitesService.urlPrefix + this.baseURL + "/" + id, {
            headers: this.authService.getAuthHeaders(),
        });
    }

    /**
     * Busca lista de Parceiros de Carta Consórcio
     * @param params Parâmetros de filtro e paginação
     * @returns Observable contendo array de parceiros
     */
    getAll(
        params: Record<string, unknown>
    ): Observable<ApiPaginationResponseDataNonNullable<ParceiroCartaConsorcioModel>> {
        const paramHttp = this.utilitesService.formurlencoded(params);
        let env = "";
        if (paramHttp !== null && paramHttp !== "") {
            env = "?" + paramHttp;
        }

        return this._http.get<ApiPaginationResponseDataNonNullable<ParceiroCartaConsorcioModel>>(
            this.utilitesService.urlPrefix + this.baseURL + env,
            {
                headers: this.authService.getAuthHeaders(),
            }
        );
    }

    /**
     * Deleta um Parceiro de Carta Consórcio
     * @param id ID do Parceiro de Carta Consórcio
     * @returns Observable com resultado da operação
     */
    delete(id: number): Observable<any> {
        return this._http.delete(this.utilitesService.urlPrefix + this.baseURL + "/" + id, {
            headers: this.authService.getAuthHeaders(),
        });
    }

    /**
     * Cria um novo Parceiro de Carta Consórcio
     * @param params Dados do Parceiro de Carta Consórcio
     * @returns Observable com resultado da operação
     */
    create(params: any): Observable<any> {
        return this._http.post(this.utilitesService.urlPrefix + this.baseURL, JSON.stringify(params), {
            headers: this.authService.getAuthHeaders(),
        });
    }

    /**
     * Atualiza um Parceiro de Carta Consórcio
     * @param id ID do Parceiro de Carta Consórcio
     * @param params Dados atualizados do Parceiro de Carta Consórcio
     * @returns Observable com resultado da operação
     */
    update(id: number, params: any): Observable<any> {
        return this._http.put(this.utilitesService.urlPrefix + this.baseURL + "/" + id, JSON.stringify(params), {
            headers: this.authService.getAuthHeaders(),
        });
    }
}
